import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { getWithAuth, postWithAuth, putWithAuth } from "../../../http";
import { CompanySetting } from "../companySettings/companySettingsApi";

export interface DefaultCompanySetting {
    id: string;
    type: string;
    code: string;
    value: string;
    isActive: boolean;
    isFixed: boolean;
    createDate: Date;
    createdBy: string;
    modifiedBy: string;
    modifyDate: Date;
}

export interface DefaultCompanySettingPayload {
    id?: string;
    type: string;
    code: string;
    value: string;
    isActive: boolean;
    isFixed: boolean;
}

export interface RegenerateCompanySettingsPayload {
    overwrite: boolean;
    companyId?: number;
}

export const loadDefaultCompanySettings = createAsyncThunk<DefaultCompanySetting[], void, AppThunkAPIType>("default-company-settings/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-settings/default` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as DefaultCompanySetting[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createDefaultCompanySettings = createAsyncThunk<DefaultCompanySetting, DefaultCompanySettingPayload, AppThunkAPIType>("default-company-settings/create", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-settings/default`, payload: setting }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as DefaultCompanySetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateCompanySetting = createAsyncThunk<DefaultCompanySetting, DefaultCompanySettingPayload, AppThunkAPIType>("default-company-settings/update", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/sys/company-settings/default/${setting.id}`, payload: setting }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as DefaultCompanySetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const regenerateCompanySettings = createAsyncThunk<CompanySetting[], RegenerateCompanySettingsPayload, AppThunkAPIType>("default-company-settings/regenerate", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-settings/regenerate`, payload: setting }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as CompanySetting[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})